import { useState } from "react";
import Newspapers    from "./Newspapers";
import Subscriptions from "./Subscriptions";
import Payments      from "./Payments";
import PaymentHistory from "./PaymentHistory";
import Profile from "./Profile";

const NAV = [
  { section: "Discover",
    items: [{ id: "newspapers", label: "Browse Papers", icon: "📰" },]
  },
  { section: "My Account",
    items: [
      { id: "subscriptions", label: "My Subscriptions", icon: "⭐" },
      { id: "bill",          label: "Pay Bill",         icon: "💸" },
      { id: "history",       label: "Payment History",  icon: "🧾" },
      { id: "profile",       label: "My Profile",       icon: "👤" },
    ]
  },
];

const PAGE_TITLES = {
  newspapers:    "Browse Newspapers",
  subscriptions: "My Subscriptions",
  bill:          "Pay Bill",
  history:       "Payment History",
  profile: "My Profile",
};

function UserDashboard() {
  const [active, setActive] = useState("newspapers");
  const userName = localStorage.getItem("userName") || "User";

  const renderPage = () => {
    switch (active) {
      case "newspapers":    return <div className="page"><Newspapers /></div>;
      case "subscriptions": return <div className="page"><Subscriptions /></div>;
      case "bill":          return <div className="page"><Payments /></div>;
      case "history":       return <div className="page"><PaymentHistory /></div>;
      case "profile":       return <div className="page"><Profile /></div>;
      default: return null;
    }
  };

  return (
    <div className="app-shell">
      {/* ── SIDEBAR ──────────────────────────────── */}
      <aside className="sidebar">
        <div className="sidebar-logo">
          <div className="logo-mark">📰</div>
          <div className="logo-name">PressManager</div>
          <div className="logo-tagline">Subscriber Portal</div>
        </div>

        <nav className="sidebar-nav">
          {NAV.map(group => (
            <div key={group.section}>
              <div className="nav-group-label">{group.section}</div>
              {group.items.map(item => (
                <div
                  key={item.id}
                  className={`nav-item ${active === item.id ? "active" : ""}`}
                  onClick={() => setActive(item.id)}
                >
                  <span className="nav-icon">{item.icon}</span>
                  {item.label}
                </div>
              ))}
            </div>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-user">
            <div className="user-avatar">{userName[0]?.toUpperCase()}</div>
            <div className="user-info">
              <div className="user-name">{userName}</div>
              <div className="user-role">Subscriber</div>
            </div>
          </div>
        </div>
      </aside>

      {/* ── MAIN ─────────────────────────────────── */}
      <main className="main-content">
        <div className="topbar">
          <div className="topbar-title">{PAGE_TITLES[active]}</div>
          <div className="topbar-right">
            <span className="role-pill user">Subscriber</span>
          </div>
        </div>
        {renderPage()}
      </main>
    </div>
  );
}

export default UserDashboard;
